import clsx from 'clsx';
import { ReactElement } from 'react';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './EntryFieldGeneric.module.css';

export interface EntryFieldGenericProps {
  id: string;
  title: string;
  error?: string;
  content: ReactElement;
}

export const EntryFieldGeneric = ({ id, title, error, content }: EntryFieldGenericProps) => {
  return (
    <>
      <div className={clsx(style.configTitle)} id={id}>
        {title}
      </div>
      {error && <div className={clsx(style.error, globalStyle.textSmall, globalStyle.textBold)}>{error}</div>}
      <div className={clsx(style.fieldRoot)}>{content}</div>
    </>
  );
};
